<div class="flex items-center justify-center w-full md:p-4">
    <span>Os comentários já foram preenchidos. Obrigado :)</span>
</div>
